import React, {ChangeEvent, useState} from 'react';

interface InputListProps {
    addNewFieldText: string;
    dataSource?: string[];
    onListItemsChange?: (value: string[]) => void;
    onInputChange?: (value: string) => void;
    onNewInputAdded?: () => void;
    onRemoveInput?: () => void;
}

const InputList: React.FC<InputListProps> = ({ addNewFieldText, dataSource, onListItemsChange, onInputChange, onNewInputAdded, onRemoveInput})  => {
    const [inputs, setInputs] = useState(dataSource || ['']); // Array to store input values
    
    const handleInputChange = (index: any, event: ChangeEvent<HTMLInputElement>) => {
        const newInputs = [...inputs];
        newInputs[index] = event.target.value;
        setInputs(newInputs);
        
        if (onInputChange) {
            onInputChange(event.target.value);
        }

        if (onListItemsChange) {
            onListItemsChange(newInputs);
        }
    };

    const handleAddInput = () => {
        const newInputs = [...inputs, ''];
        setInputs(newInputs);
        
        if (onNewInputAdded) {
            onNewInputAdded();
        }

        if (onListItemsChange) {
            onListItemsChange(newInputs);
        }
    };

    const handleRemoveInput = (index: any) => {
        const newInputs = [...inputs];
        newInputs.splice(index, 1);
        setInputs(newInputs);
        
        if (onRemoveInput) {
            onRemoveInput();
        }

        if (onListItemsChange) {
            onListItemsChange(newInputs);
        }
    };
    
    return (
        <div className={"multi-text-parent"}>
            {inputs.map((input, index) => (
                <div key={index} className={"multi-text-input-container input-group margin-bottom-5"}>
                    <input
                        type="text"
                        value={input}
                        onChange={(event) => handleInputChange(index, event)}
                        className={"form-control field-answer-multi-text-input"}
                    />
                    <span className={"input-group-btn"}>
                        <button onClick={() => handleRemoveInput(index)} className={"btn btn-toxnot-danger remove-multi-text-button"}>Remove</button>
                    </span>
                </div>
            ))}
            <button className={"btn btn-default add-multi-text-button"} onClick={handleAddInput}>{addNewFieldText}</button>
        </div>
    );
};

export default InputList;